module.exports = __webpack_public_path__ + "static/media/designPatent_30-1028639.44fc15be.png";